import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  useToast,
  Box,
} from '@chakra-ui/react';
import React from 'react';

export default function ShareProjectModal(props: any) {
  const toast = useToast();

  const copyToClipBoard = async (copyMe: string) => {
    try {
      await navigator.clipboard.writeText(copyMe);
      toast({
        title: 'Text Copied.',
        description: 'Text copied to clipboard successfully',
        status: 'success',
        duration: 9000,
        isClosable: true,
      });
    } catch (err) {
      toast({
        title: '.',
        description: 'Something went wrong while copying.',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal onClose={props?.onClose} isOpen={props?.isOpen} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Share project</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box
            h="37px"
            borderRadius="12px"
            background="rgba(0, 0, 0, 0.10)"
            display="flex"
            gap="4px"
            alignItems="center"
            justifyContent="flex-start"
          >
            <Text fontSize="14px" color="#000" paddingLeft="10px">
              {window.location.href}
            </Text>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button
            color="white"
            borderRadius="12px"
            background="#5772FF"
            fontSize=" 14px"
            fontStyle="normal"
            fontWeight=" 500"
            lineHeight="normal"
            h={'32px'}
            onClick={() => copyToClipBoard(window.location.href)}
            _hover={{
              bg: '#5772FF',
              color: '#000',
            }}
          >
            Copy
          </Button>
          {/* <Button colorScheme="blue" mr={3} onClick={() => copyToClipBoard(window.location.href)}>
            
          </Button> */}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
